import { BRAND, SSA_LOGO } from "../lib/brand";

/* ───────────────────── LOGO ─────────────────────
   `subtitle` defaults to the availability tracker so every screen inside that
   app is unchanged. The platform launcher passes null: it fronts all the SSA
   apps, so naming one of them there would be wrong. */
export function SartellLogo({ size = "lg", subtitle = "PLAYER AVAILABILITY TRACKER" }) {
  const sz = size === "lg" ? "w-20 h-20" : "w-12 h-12";
  const txt = size === "lg" ? "text-3xl" : "text-xl";
  return (
    <div className="flex flex-col items-center gap-2">
      <img src={SSA_LOGO} alt="Sartell Soccer Association"
        className={`${sz} rounded-full shadow-lg object-cover`} />
      <div className="text-center">
        <h1 className={`${txt} font-extrabold tracking-tight leading-none`}
          style={{ color: BRAND.accent }}>
          Sartell Soccer
        </h1>
        {subtitle && (
          <p className="text-sm font-medium tracking-wide" style={{ color: BRAND.primary }}>{subtitle}</p>
        )}
      </div>
    </div>
  );
}

/* ───────────────────── SMALL LOGO (header) ───────────────────── */
export function SmallLogo() {
  return (
    <img src={SSA_LOGO} alt="SSA"
      className="w-10 h-10 rounded-full object-cover shadow-sm" />
  );
}
